(() => {
  const groupNames = { hearts: 'Cuore', stones: 'Pietra di nascita', months: 'Pietra di nascita', zodiac: 'Segno zodiacale', letters: 'Iniziale', heartLetter: 'Lettera' };
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  class Personalization extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.config = JSON.parse(this.querySelector('[data-vm-config]').textContent);
      // Native-variant-only products need no custom validator. Remove any empty
      // component left by cached markup so it cannot block the product form.
      if (!this.config) { this.remove(); return; }
      this.ready = true;
      this.variant = JSON.parse(this.querySelector('[data-vm-variant]').textContent);
      this.host = this.querySelector('[data-vm-fields]');
      this.error = this.querySelector('[role="alert"]');
      this.rows = [];
      this.build();
      this.sync(this.variant);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (String(data.sectionId) === this.dataset.section) this.sync(data.variant);
      });
      // Capture validation also covers other form submitters, without overriding native cart handling.
      this.form = this.closest('form');
      this.onSubmit = (event) => {
        if (!this.validate()) { event.preventDefault(); event.stopImmediatePropagation(); }
      };
      this.form.addEventListener('submit', this.onSubmit, true);
      const defaultSelection=()=>{
        if(!this.isConnected||!this.config.defaultCount||new URLSearchParams(location.search).has('variant'))return;
        const option=this.closest('product-info')?.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown')[this.config.countIndex];
        const radio=Array.from(option?.querySelectorAll('input[type="radio"]')||[]).find(input=>parseInt(input.value,10)===this.config.defaultCount);
        if(radio&&!radio.checked){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
      };
      // The head script can upgrade this element before the deferred product-info script.
      // Wait for the native variant controller before dispatching its initial selection.
      Promise.all(['product-info','product-form','variant-selects'].map(name=>customElements.whenDefined(name))).then(defaultSelection);
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.dialog?.close();
    }
    icon(option, row) {
      if(this.config.child&&row?.gender&&option){
        const group=row.gender.value==='Bambino'?'child_boy':'child_girl';
        option=window.VM_PERSONALIZATION_OPTIONS[group]?.find(item=>item.value===option.value)||option;
      }
      if (option?.asset) {
        const image = el('img'); image.src = this.dataset.assetBase + option.asset;
        image.alt = ''; image.width = 40; image.height = 40; image.loading = 'lazy';
        return image;
      }
      const letter=el('span', 'vm-personalization__letter', option?.label || '');
      letter.setAttribute('aria-hidden','true');return letter;
    }
    optionsFor(groups) {
      return groups.flatMap(group => (window.VM_PERSONALIZATION_OPTIONS[group] || []).map(option => ({...option, group})));
    }
    build() {
      const config = this.config;
      if (config.modal) {
        this.setAttribute('data-modal', '');
        this.launcher = el('button', 'vm-personalization__launcher');
        this.launcher.type = 'button'; this.launcher.setAttribute('aria-haspopup', 'dialog');
        this.launcher.addEventListener('click', () => this.openDialog());
        this.host.append(this.launcher);
      } else {
        const heading = el('p', 'vm-personalization__heading');
        if (config.heading?.startsWith('Scegli il tuo ')) heading.append('Scegli il tuo ', el('strong', '', config.heading.slice(14)));
        else heading.textContent = config.heading || '';
        this.host.append(heading);
      }
      this.container = el('div', 'vm-personalization__rows');
      if (config.modal) this.container.hidden = true;
      this.host.append(this.container);
      for (let index = 0; index < config.max; index++) {
        const field = config.fields?.[index] || {label: config.label + ' ' + (index + 1), groups: config.groups};
        const wrapper = el('div', 'vm-personalization__row');
        const id = `vm-property-${this.dataset.section}-${index}`;
        const label = el('label', 'vm-personalization__label', field.label);
        label.htmlFor = id; wrapper.append(label);
        const input = el(config.text ? 'input' : 'select', 'vm-personalization__input');
        input.id = id; input.name = `properties[${config.property ? config.property + ' ' + (index + 1) : field.label}]`;
        input.required = true;
        const options = this.optionsFor(field.groups);
        let trigger;
        if (config.text) {
          input.type = 'text'; input.maxLength = config.maxLength; input.autocomplete = 'off';
          input.placeholder = 'Inserisci il nome ' + (index + 1);
        } else {
          if(!config.defaultValue)input.append(new Option("Seleziona un'opzione", ''));
          for (const group of field.groups) {
            const optgroup = el('optgroup'); optgroup.label = groupNames[group] || 'Pietra di nascita';
            for (const option of options.filter(o => o.group === group)) optgroup.append(new Option(option.label, option.value));
            input.append(optgroup);
          }
          if(config.defaultValue)input.value=config.defaultValue;
          if ((config.preview && !config.nativeSelect) || config.modal) {
            input.classList.add('visually-hidden'); input.tabIndex = -1; input.setAttribute('aria-hidden','true');
            trigger = el('button', 'vm-personalization__choice', "Seleziona un'opzione");
            trigger.type = 'button'; trigger.setAttribute('aria-haspopup', 'dialog');
            trigger.setAttribute('aria-label', field.label + ": Seleziona un'opzione");
            trigger.addEventListener('click', () => this.openDialog(index));
            wrapper.append(trigger);
          }
        }
        wrapper.append(input);
        const row = {wrapper, input, trigger, label:field.label, options};
        if (config.child) {
          const gender = el('select', 'vm-personalization__input');
          gender.name = `properties[Tipo ciondolo ${index + 1}]`;
          gender.setAttribute('aria-label', `Tipo ciondolo ${index + 1}`);
          gender.append(new Option('Bambina','Bambina'), new Option('Bambino','Bambino'));
          gender.addEventListener('change', () => this.update());
          wrapper.insertBefore(gender, trigger || input); row.gender = gender;
        }
        input.addEventListener('change', () => this.update());
        input.addEventListener('input', () => { input.setCustomValidity(''); this.error.hidden = true; });
        this.container.append(wrapper); this.rows.push(row);
      }
      if (config.preview || config.modal) {
        const reset = el('button', 'vm-personalization__reset', this.dataset.resetLabel || 'Azzera Scelte'); reset.type = 'button';
        reset.addEventListener('click', () => { this.rows.forEach(r => r.input.value = ''); this.update(); });
        this.host.append(reset);
        this.host.append(el('p', 'vm-personalization__preview-label', this.dataset.previewLabel || 'Anteprima del tuo gioiello:'));
        this.preview = el('div', 'vm-personalization__preview');
        this.preview.setAttribute('aria-live', 'polite'); this.host.append(this.preview);
        this.host.append(el('p', 'vm-personalization__hint', 'Anteprima indicativa delle tue scelte.'));
      }
    }
    sync(variant) {
      this.variant = variant;
      const rawCount = this.config.countIndex === null ? this.config.count : parseInt(variant?.options?.[this.config.countIndex], 10);
      this.count = Math.max(1, Math.min(this.config.max, rawCount || this.count || this.config.count));
      this.rows.forEach((row, index) => {
        const active = index < this.count;
        row.wrapper.hidden = !active;
        row.input.disabled = !active; row.input.required = active;
        if (row.gender) row.gender.disabled = !active;
        if (!active) row.input.setCustomValidity('');
      });
      this.classList.toggle('vm-personalization--silver', variant?.options?.some(v => /argento|silver/i.test(v)) || false);
      this.update();
    }
    update() {
      const active = this.rows.slice(0, this.count);
      const completed = active.filter(r => r.input.value.trim()).length;
      if (this.launcher) this.launcher.replaceChildren(el('span', '', '+  ' + this.config.heading + ' (' + (this.dataset.freeLabel || 'Gratis') + ')'), el('span', 'vm-personalization__launcher-count', `${completed}/${this.count}`));
      this.preview?.replaceChildren();
      active.forEach(row => {
        row.input.setCustomValidity('');
        const option = row.options.find(o => o.value === row.input.value);
        if (row.trigger) {
          row.trigger.replaceChildren();
          if (option) row.trigger.append(this.icon(option,row));
          row.trigger.append(el('span', '', option?.label || "Seleziona un'opzione"));
          row.trigger.setAttribute('aria-label', row.label + ': ' + (option?.label || "Seleziona un'opzione"));
          row.trigger.removeAttribute('aria-invalid');
        }
        if (this.preview) {
          const charm = el('span', 'vm-personalization__charm');
          if (option) { charm.append(this.icon(option,row)); charm.title = row.label + ': ' + (row.gender ? row.gender.value + ', ' : '') + option.label; }
          else { charm.classList.add('vm-personalization__placeholder'); charm.textContent = '?'; }
          this.preview.append(charm);
        }
      });
      this.error.hidden = true;
    }
    openDialog(index) {
      this.dialog?.close();
      const inline = !this.config.modal && index !== undefined;
      const dialog = el('dialog', 'vm-personalization-dialog' + (inline ? ' vm-personalization-dialog--inline' : ''));
      const titleId = 'vm-dialog-title-' + this.dataset.section;
      dialog.setAttribute('aria-labelledby', titleId);
      const top = el('div', 'vm-personalization-dialog__header');
      const title = el('h2', '', inline ? this.rows[index].label : this.config.heading); title.id = titleId;
      const close = el('button', 'vm-personalization-dialog__close', '×'); close.type = 'button'; close.setAttribute('aria-label','Chiudi');
      close.addEventListener('click', () => dialog.close()); top.append(title, close); dialog.append(top);
      const body = el('div', 'vm-personalization-dialog__body');
      const rows = index === undefined ? this.rows.slice(0, this.count) : [this.rows[index]];
      for (const row of rows) {
        const fieldset = el('fieldset', 'vm-personalization-dialog__field');
        fieldset.append(el('legend','',row.label));
        if (row.gender) {
          const genders=el('div','vm-personalization-dialog__genders');
          for(const value of ['Bambina','Bambino']){
            const gender=el('button','vm-personalization-dialog__gender',value);gender.type='button';
            gender.setAttribute('aria-pressed',String(row.gender.value===value));
            gender.addEventListener('click',()=>{
              row.gender.value=value;this.update();
              genders.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(button===gender)));
              fieldset.querySelectorAll('.vm-personalization-dialog__option').forEach((button,i)=>button.firstElementChild.replaceWith(this.icon(row.options[i],row)));
            });genders.append(gender);
          }fieldset.append(genders);
        }
        for (const group of [...new Set(row.options.map(o=>o.group))]) {
          fieldset.append(el('h3','vm-personalization-dialog__group',groupNames[group] || 'Pietra di nascita'));
          const grid = el('div','vm-personalization-dialog__grid');
          grid.dataset.group=group;
          for (const option of row.options.filter(o=>o.group===group)) {
            const button = el('button','vm-personalization-dialog__option'); button.type='button';
            button.setAttribute('aria-pressed',String(row.input.value===option.value));
            button.append(this.icon(option,row),el('span','',option.label));
            button.addEventListener('click',()=>{
              row.input.value=option.value;this.update();
              fieldset.querySelectorAll('.vm-personalization-dialog__option[aria-pressed]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
              if(index!==undefined)dialog.close();
            });
            grid.append(button);
          }
          fieldset.append(grid);
        }
        body.append(fieldset);
      }
      dialog.append(body);
      const confirm = el('button','button vm-personalization-dialog__confirm','Conferma'); confirm.type='button';
      confirm.addEventListener('click',()=>{
        const missing=rows.find(r=>!r.input.value);
        if(missing){ const pos=rows.indexOf(missing); body.children[pos].scrollIntoView({block:'start'}); body.children[pos].querySelector('button')?.focus(); return; }
        dialog.close();
      });
      if(!inline)dialog.append(confirm);
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      const dismiss=event=>{if(inline&&!dialog.contains(event.target)&&event.target!==this.rows[index].trigger)dialog.close();};
      document.addEventListener('pointerdown',dismiss);
      dialog.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();dialog.close();}});
      let detachPosition=()=>{};
      dialog.addEventListener('close',()=>{
        document.removeEventListener('pointerdown',dismiss);detachPosition();dialog.remove();
        // A previous dialog's asynchronous close event must not clear a newly opened picker.
        if(this.dialog===dialog){this.dialog=null;if(inline)this.rows[index].trigger.focus({preventScroll:true});}
      });
      if(this.classList.contains('vm-personalization--silver'))dialog.classList.add('vm-personalization--silver');
      this.dialog=dialog;
      if(inline){
        const wrapper=this.rows[index].wrapper;
        const position=()=>{
          const rect=wrapper.getBoundingClientRect();
          const top=Math.max(12,document.querySelector('.vm-header-section')?.getBoundingClientRect().bottom||0,document.querySelector('.gm-quantity-offer--pinned')?.getBoundingClientRect().bottom||0);
          const below=Math.max(0,window.innerHeight-rect.bottom-16);
          const above=Math.max(0,rect.top-top-8);
          const opensAbove=below<Math.min(360,above);
          dialog.dataset.placement=opensAbove?'above':'below';
          dialog.style.setProperty('--vm-picker-height',Math.min(360,opensAbove?above:below)+'px');
        };
        wrapper.append(dialog);position();dialog.show();
        window.addEventListener('resize',position);
        window.addEventListener('scroll',position,{passive:true});
        detachPosition=()=>{window.removeEventListener('resize',position);window.removeEventListener('scroll',position);};
      }
      else {document.body.append(dialog);dialog.showModal();}
    }
    validate() {
      const missing=this.rows.slice(0,this.count).find(row=>!row.input.value.trim()||!row.input.checkValidity());
      if (!missing) return true;
      this.error.hidden=false;
      if(this.config.modal){this.launcher.focus();this.openDialog();}
      else if(missing.trigger){missing.trigger.setAttribute('aria-invalid','true');missing.trigger.focus();}
      else {missing.input.setCustomValidity(this.config.text?'Inserisci il nome, massimo '+this.config.maxLength+' caratteri.':"Seleziona un'opzione.");missing.input.reportValidity();}
      return false;
    }
  }
  if (!customElements.get('vm-personalization')) customElements.define('vm-personalization', Personalization);
})();
